import { t } from 'i18next'
import { ITableListModel, TABLE_REQUEST_MODE, TableListRequestType, countData, deleteData, getData, patchData, postData } from '../utils/db'
import { syncTranslation } from '../utils/translate';
import { TProject } from './project'
import { TUser } from './user'
import { parseQueryArguments } from '@/shared';

type SubscriptionProjectListType = TableListRequestType & {
  userId: string
}

export enum ESubscriptionStatus {
  'Active' = 'active',
  'Paused' = 'paused',
  'Terminated' = 'terminated',
  'Blocked' = 'blocked',
}

/**
 * List of user/project subscription types as value/label pair
*/
type ValuePairProps = { value: string; label: string }
let subscriptionLabels: ValuePairProps[] = []
syncTranslation(() => {
  // translate the subscription status to the current language
  subscriptionLabels = Object.entries(ESubscriptionStatus).map(([label, value]) => ({
    label: t(label),
    value,
  }))
})
export const subscriptionLabelList = (smallList: boolean): ValuePairProps[] => {
  if (!smallList) return subscriptionLabels

  const included = ['active', 'paused', 'terminated']
  return subscriptionLabels.filter((item) => included.indexOf(item.value) !== -1)
}

export const getSubscriptionLabel = (subscription: string) => {
  const result = subscriptionLabels.find(item => {
    return item.value == subscription
  })
  if (result) return result.label
  return subscription
}

export type TSubscription = {
  _id: string,
  userId: string,
  user: TUser,
  projectId?: string,
  project?: TProject,
  startedAt: string,
  recurringDate: string,
  status: ESubscriptionStatus,
}

export default class SubscriptionModel implements ITableListModel<TSubscription> {
  constructor() {
  }

  public async list({ mode = TABLE_REQUEST_MODE.PAGINATION, page = 0, limit = 10, q = '' }: TableListRequestType) {
    let query = parseQueryArguments(`page=${page}&limit=${limit}`, arguments)
    if (q) query += '&q=' + encodeURI(q)
    if (mode == TABLE_REQUEST_MODE.POSITION) query += '&mode=position'

    return await getData(`/subscriptions?${query}`)
  }

  public async projectList({ mode = TABLE_REQUEST_MODE.PAGINATION, page = 0, limit = 10, q = '', userId }: SubscriptionProjectListType) {
    let query = `page=${page}&limit=${limit}`
    if (q) query += '&q=' + encodeURI(q)
    if (mode == TABLE_REQUEST_MODE.POSITION) query += '&mode=position'

    return await getData(`/subscriptions/user/${userId}/projects?${query}`)
  }

  public async read(id: string) {
    return await getData(`/subscriptions/${id}`)
  }

  public async create(subscription: any) {
    return await postData('/subscriptions', subscription)
  }

  public async update(subscriptionId: string, data: any) {
    return await patchData(`/subscriptions/${subscriptionId}`, data)
  }

  public async delete(subscriptionId: string) {
    return await deleteData(`/subscriptions/${subscriptionId}`)
  }

  public async count() {
    return await countData(`/subscriptions/count`)
  }

  public async findByUserId(userId: string) {
    return await getData(`/subscriptions/user/${userId}`)
  }

  public async findByProjrctId(projectId: string) {
    return await getData(`/subscriptions/project/${projectId}`)
  }
}